// extracted by mini-css-extract-plugin
export var breadcrumbs = "Breadcrumb-module--breadcrumbs--LDYQm";
export var page404Title = "Breadcrumb-module--page404-title--6xLMn";